<template>
  <div class="text-xs-center">
    <v-dialog
      scrollable
      v-model="dialog"
      width="350"
      :fullscreen="mobile">
      <template v-slot:activator="{ on }">
        <v-btn
          flat
          :color="mobile ? 'white' : 'primary'"
          dark
          v-on="on"
        >
          {{ realFrom }} - {{ realTo }}
        </v-btn>
      </template>

      <v-card style="display: flex; flex-direction: column;">
        <v-card-title style="display: block; padding: 0; flex: none;">
        <v-toolbar
          flat
          class="simple"
          color="primary"
          extension-height="130"
          dark>
          <v-toolbar-title>Filtra dati</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-radio-group
            @change="ev => localCalendar.type = ev"
            style="justify-content: flex-end; "
            :value="localCalendar.type"
            row>
            <v-radio color="white" label="Data" value="D"></v-radio>
            <v-radio color="white" label="Periodo" value="P"></v-radio>
          </v-radio-group>
          <template v-slot:extension>
            <v-layout class="dates-container" column>
              <div class="dates-indicator">
                <span class="circle"></span>
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="circle"></span>
              </div>
              <v-text-field
                readonly
                color="white"
                flat
                placeholder="Da..."
                :value="formattedFrom"
                solo
              ></v-text-field>
              <div class="separator"></div>
              <v-text-field
                readonly
                color="white"
                flat
                placeholder="A..."
                :value="formattedTo"
                solo
              ></v-text-field>
            </v-layout>
          </template>
        </v-toolbar>
        </v-card-title>
        <v-card-text style="padding: 0; flex: 1;">
          <template v-if="localCalendar.type == 'D'">
            <div class="v-picker__body">
              <v-progress-linear
                class="my-0"
                color="accent"
                v-if="loadingChiusure"
                :indeterminate="true" />
              <v-date-picker-header
                v-if="!['YEAR', 'CHIUSURE-FROM', 'CHIUSURE-TO'].includes(activePicker)"
                @toggle="toggleHeader"
                @input="headerEvent"
                :min="monthMin"
                :max="monthMax"
                :value="headerValue"
                locale="it"/>
              <v-date-picker-years
                v-if="activePicker === 'YEAR'"
                @input="ev => clickEvent(ev, 'year')"
                locale="it"
                :value="headerValue"
                :min="yearmin"
                :max="yearmax"/>
              <v-date-picker-month-table
                v-if="activePicker === 'MONTH'"
                @click:month="ev => clickEvent(ev, 'month')"
                :min="monthMin"
                :max="monthMax"
                :table-date="headerValue"
                :value="headerValue"
                locale="it"/>
              <v-date-picker-date-table
                v-if="activePicker === 'DATE'"
                @click:date="ev => clickEvent(ev, 'date')"
                firstDayOfWeek="1"
                locale="it"
                :min="dateMin"
                :max="dateMax"
                :value="selectingFirst ? formattedDateValue : [tmpFrom]"
                :table-date="headerValue"/>
            </div>
            <v-divider></v-divider>
            <v-layout class="chiusure">
              <v-flex
                :key="tf"
                v-for="tf in ['from', 'to']"
                xs6>
                <v-list class="chiusure">
                  <!--<v-subheader>{{tf == 'to' ? 'Da' : 'A'}} chiusura</v-subheader>-->
                  <v-list-tile v-if="chiusure[tf].length == 0" > Nessuna chiusura </v-list-tile>
                  <v-list-tile
                    @click="clickEvent(chiusura, `chiusura-${tf}`)"
                    :key="index"
                    v-for="([locale, chiusura], index) in chiusure[tf]">
                    <v-list-tile-action>
                      <v-icon
                        v-if="[localCalendar.from, localCalendar.to].includes(chiusura)"
                        color="accent">mdi-star</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <badge-locale
                          v-if="multiMode"
                          :locale="locale" /> {{ chiusura | time }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <v-list>
              <v-list-tile
                @click="localCalendar.period = periodo.v"
                :key="periodo.v"
                v-for="periodo in periodi">
                <v-list-tile-action>
                  <v-icon
                    v-if="localCalendar.period == periodo.v"
                    color="accent">mdi-star</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ periodo.d }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="max-height: 52px;">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="tmpFrom = null; activePicker = 'DATE'; dialog = false"
          >
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import calendar from '@/mixins/calendar';
import moment from 'moment';

export default {
  name: 'calendar',
  mixins: [calendar],
  data: () => ({
    initChiusure: false,
    tmpFrom: null,
    loadingChiusure: false,
    selectingFirst: true,
    dialog: false,
    activePicker: 'DATE',
    headerValue: moment().format('YYYY-MM'),
    localCalendar: {},
    chiusure: {
      from: [],
      to: [],
    },
    periodi: [{
      d: 'Oggi',
      v: 'O',
    }, {
      d: 'Ieri',
      v: 'I',
    }, {
      d: 'Ultimi 7 giorni',
      v: 'U7G',
    }, {
      d: 'Mese corrente',
      v: 'MC',
    }, {
      d: 'Anno corrente',
      v: 'AC',
    }],
  }),
  async mounted() {
    this.localCalendar = { ...this.calendar };
    this.headerValue = moment(this.localCalendar.to).format('YYYY-MM');
    await this.refreshChiusure();
  },
  watch: {
    async dialog(open) { //eslint-disable-line
      if (!open && JSON.stringify(this.localCalendar) !== JSON.stringify(this.calendar)) {
        this.calendarSet(this.localCalendar);
      }
    },
    'localCalendar.type': function(newType, oldType) { //eslint-disable-line
      if (!!oldType && newType === 'P') {
        this.localCalendar.period = 'O';
      }
    },
    'localCalendar.period': function(newPeriod, oldPeriod) { //eslint-disable-line
      if (!oldPeriod) return;
      switch (newPeriod) {
        case 'O':
          this.localCalendar.from = moment().format('YYYY-MM-DD');
          this.localCalendar.to = moment().format('YYYY-MM-DD');
          break;
        case 'I':
          this.localCalendar.from = moment().subtract(1, 'day').format('YYYY-MM-DD');
          this.localCalendar.to = moment().subtract(1, 'day').format('YYYY-MM-DD');
          break;
        case 'U7G':
          this.localCalendar.from = moment().subtract(7, 'days').format('YYYY-MM-DD');
          this.localCalendar.to = moment().format('YYYY-MM-DD');
          break;
        case 'MC':
          this.localCalendar.from = moment().startOf('month').format('YYYY-MM-DD');
          this.localCalendar.to = moment().format('YYYY-MM-DD');
          break;
        case 'AC':
          this.localCalendar.from = moment().startOf('year').format('YYYY-MM-DD');
          this.localCalendar.to = moment().format('YYYY-MM-DD');
          break;
        default:
          break;
      }
    },
  },
  methods: {
    toggleHeader() {
      if (this.activePicker === 'DATE') {
        this.activePicker = 'MONTH';
        this.headerValue = `${this.headerValue.split('-')[0]}`;
      } else {
        this.activePicker = 'YEAR';
        this.headerValue = moment(this.headerValue).year();
      }
    },
    headerEvent(ev) {
      this.headerValue = ev;
    },
    async refreshChiusure() {
      this.loadingChiusure = true;
      const { from, to } = await this.loadChiusure(this.localCalendar).min(1000);
      this.chiusure.from = from;
      this.chiusure.to = to;
      this.loadingChiusure = false;
    },
    async clickEvent(ev, type) {
      switch (type) {
        case 'year':
          this.activePicker = 'MONTH';
          this.headerValue = `${ev}-`;
          break;
        case 'month':
          this.activePicker = 'DATE';
          this.headerValue = `${ev}-01`;
          break;
        case 'chiusura-from':
          if (this.localCalendar.from === ev) {
            this.localCalendar.from = moment(ev).format('YYYY-MM-DD');
            return;
          }
          this.localCalendar.from = ev;
          break;
        case 'chiusura-to':
          if (this.localCalendar.to === ev) {
            this.localCalendar.to = moment(ev).format('YYYY-MM-DD');
            return;
          }
          this.localCalendar.to = ev;
          break;
        default:
          if (this.selectingFirst) {
            this.tmpFrom = ev;
            this.selectingFirst = false;
          } else {
            this.localCalendar.from = this.tmpFrom;
            this.localCalendar.to = ev;
            this.selectingFirst = true;
            await this.refreshChiusure();
          }
          break;
      }
    },
  },
  computed: {
    realFrom() {
      const formatted = moment(this.calendar.from, 'YYYY-MM-DD', true);
      if (formatted.isValid()) return formatted.format('DD/MM/YYYY');
      return moment(this.calendar.from).format('DD/MM/YYYY HH:mm');
    },
    realTo() {
      const formatted = moment(this.calendar.to, 'YYYY-MM-DD', true);
      if (formatted.isValid()) return formatted.format('DD/MM/YYYY');
      return moment(this.calendar.to).format('DD/MM/YYYY HH:mm');
    },
    formattedFrom() {
      const formatted = moment(this.localCalendar.from, 'YYYY-MM-DD', true);
      if (formatted.isValid()) return formatted.format('DD/MM/YYYY');
      return moment(this.localCalendar.from).format('DD/MM/YYYY HH:mm');
    },
    formattedTo() {
      const formatted = moment(this.localCalendar.to, 'YYYY-MM-DD', true);
      if (formatted.isValid()) return formatted.format('DD/MM/YYYY');
      return moment(this.localCalendar.to).format('DD/MM/YYYY HH:mm');
    },
    noTimeFrom() {
      return moment(this.localCalendar.from).format('DD/MM/YYYY');
    },
    noTimeTo() {
      return moment(this.localCalendar.to).format('DD/MM/YYYY');
    },
    headerMin() {
      if (!this.selectingFirst) return moment(this.tmpFrom || this.localCalendar.from).format('YYYY');
      return `${this.yearmin}`;
    },
    headerMax() {
      return `${this.yearmax}`;
    },
    monthMin() {
      if (!this.selectingFirst) return moment(this.tmpFrom || this.localCalendar.from).format('YYYY-MM');
      return null;
    },
    monthMax() {
      const now = moment();
      if (moment(this.headerValue).year() === now.year()) {
        return `${now.year()}-${(now.month() + 1).toString().padStart(2, '0')}`;
      }
      return `${moment(this.headerValue).year()}-12`;
    },
    dateMin() {
      if (!this.selectingFirst) return this.tmpFrom || this.localCalendar.from;
      return null;
    },
    dateMax() {
      return moment().endOf('month').format('YYYY-MM-DD');
    },
    formattedDateValue() {
      return [this.localCalendar.from, this.localCalendar.to]
        .map(date => moment(date).format('YYYY-MM-DD'));
    },
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
};
</script>

<style lang="stylus" scoped>
.chiusure
  max-height 80px
  overflow auto
.v-toolbar
  >>> .v-input--radio-group
    .v-messages
      display none
    .v-input__slot
      margin 0
.v-toolbar__extension
  margin-bottom 8px
.dates-container
  margin-left 50px
  position relative
  >>> .dates-indicator
    position absolute
    display flex
    flex-direction column
    justify-content space-evenly
    align-items center
    height 80%
    width 30px
    top 0
    bottom 0
    margin auto
    left -50px
    .circle
      width 10px
      height 10px
      border-radius 5px
      border 2px solid #fff
    .dot
      width 4px
      height 4px
      border-radius 4px
      background-color #fff
  >>> .separator
    width 100%
    height 1px
    background #fff
  >>> .v-input
    .v-input__slot
      background transparent

  >>> .v-input
    .v-input__slot
      margin 0
</style>
